const TemplateUI = {
    cssCocoUI: ({
        enableCustomCss,
        btnColor,
        btnBackgroundColor,
        textColor,
        cssText
    }) => {
        let stringCss = ``;
        if(
            textColor !== undefined && 
            textColor !== null && 
            textColor !== ''
        ) {
            stringCss += `
                .am-navbar-light .am-navbar-title {
                    color: ${textColor}!important;
                }
                .del-address {
                    color: ${textColor}!important;
                }
                .menuContainer .mainMenuContainer .gridItemBox .menuHeader {
                    color: ${textColor}!important;
                }   
                .mainMenuContainer .gridContainer .itemslist .li-text h4 {
                    color: ${textColor}!important;
                }
                .mainMenuContainer .gridContainer .itemslist .li-text .priceDetails .li-sub .itemPrice {    
                    color: ${textColor}!important;
                }               
                .carthead, .paymentReceipt .am-modal-header, .am-modal.socialprompt .am-modal-body .info_header, .profileDrawer .info_header {
                    color: ${textColor}!important;
                }
                .cocoMenu.cocoHorizontalMenu #cocomunu-horizontal li {
                    color: ${textColor};
                }
                .am-navbar-title {
                    color: ${textColor};
                }
                .am-navbar-title {
                    color: ${textColor};
                }
                .ant-drawer .ant-drawer-content-wrapper .ant-drawer-content .ant-drawer-body .drawermenu, .ant-drawer .ant-drawer-content-wrapper .ant-drawer-content .ant-drawer-body .footermenu {
                    color: ${textColor};
                }
                .cartlinks {
                    color: ${textColor}!important;
                }
                .rewardVoucherInfo {
                    color: ${textColor}!important;
                }
                .recomSection > h3, .recomSection .recomItems .li-text h4, .cart_item .am-list-line .am-list-content .cartItemName > .innerItemName .cartItem {
                    color: ${textColor}!important;
                }
                .cart_item .am-list-line .am-list-content .cartItemName p {
                    color: ${textColor}!important;
                }
                .recomSection .recomItems .li-text .pricewrapper .li-sub {
                    color: ${textColor}!important;
                }
                .recomSection .recomItems .li-text p.li-sub .itemPrice {
                    color: ${textColor}!important;
                }
                .carthead .am-navbar-title span, .headingTitle {
                    color: ${textColor}!important;
                }
            `;
        }
        if(
            btnColor !== undefined && 
            btnColor !== null && 
            btnColor !== '' && 
            btnBackgroundColor !== undefined && 
            btnBackgroundColor !== null && 
            btnBackgroundColor !== ''
        ) {
            stringCss += `
                .am-button {
                    background: ${btnBackgroundColor}!important;
                    color: ${btnColor}!important;
                }
                .ant-menu-item ant-menu-item-selected {
                    background: ${btnBackgroundColor}!important;
                    color: ${btnColor}!important;
                }
                #catgeory-horizontal.ant-menu-horizontal > .ant-menu-item.ant-menu-item-selected {
                    background: ${btnBackgroundColor}!important;
                    color: ${btnColor};
                    border-color: ${btnBackgroundColor};
                }
                #cocomunu-horizontal.ant-menu-horizontal > .ant-menu-item-open, #cocomunu-horizontal.ant-menu-horizontal > .ant-menu-submenu-open, #cocomunu-horizontal.ant-menu-horizontal > .ant-menu-item-selected, #cocomunu-horizontal.ant-menu-horizontal > .ant-menu-submenu-selected {
                    background: ${btnBackgroundColor}!important;
                    color: ${btnColor}!important;
                }
                .mainMenuContainer .gridContainer .itemslist .li-text .priceDetails .am-button, .mainMenuContainer .gridContainer .itemslist .li-text .priceDetails .food-stepper-select, .setmealsls .cartScreen .ant-collapse .ant-collapse-content .am-list-item:not(.addoncheckbox) .am-list-line .am-list-extra .food-stepper-container .food-stepper-select {
                    background-color: ${btnBackgroundColor}!important;
                    color: ${btnColor}!important;
                }
                .infolayout4 .am-modal-body .cocosetmeal .bottom .info_addToCart {
                    border-radius: unset!important;
                    background-color: ${btnBackgroundColor} !important;
                    color: ${btnColor} !important;
                    font-weight: 900;
                }
                .menutype4 .checkoutBtn.checkouthome .homebtn {
                    background-color: ${btnBackgroundColor} !important;
                    color: ${btnColor} !important;
                }
                .menutype4 .checkoutBtn.checkouthome::before {
                    background-color: ${btnBackgroundColor} !important;
                    color: ${btnColor} !important;
                    border-radius: unset !important;
                }
                .checkoutBtn .am-button, .optselection {
                    background-color: ${btnBackgroundColor} !important;
                    color: ${btnColor} !important;
                    border-radius: unset !important;
                }
                .menutype4 .food-stepper-select.minus, .menutype4 .food-stepper-select.plus, .menutype4 .food-stepper-select.tick {
                    background-color: ${btnBackgroundColor} !important;
                    color: ${btnColor} !important;
                }
                .recomSection .recomItems .li-text .am-button svg {
                    fill: ${btnBackgroundColor} !important;
                    color: ${btnColor} !important;
                }
            `;
        }
        if(cssText !== undefined && cssText !== null && cssText !== '') {
            stringCss += `
                ${cssText}
            `;
        }
        return stringCss;
    }
}
export default TemplateUI;
